var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ChartCard',{ref:"target",staticClass:"page-views-card",attrs:{"title":"Activity","highlights":_vm.highlights,"is-loading":_vm.isLoading}},[_c('ChartWrapper',{attrs:{"width":"100%","height":"300","type":"Line","options":_vm.chartOptions,"data":_vm.series}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }